import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    let mainDash = document.getElementById("content-area");

    if (mainDash && mainDash.scrollTop) mainDash.scrollTop = 0;
    else window.scrollTo(0, 0);
  }, [pathname]);
}

export default useScrollToTop;
